import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-login-dialog-image',
  templateUrl: './login-dialog-image.component.html',
  styleUrls: ['./login-dialog-image.component.scss']
})
export class LoginDialogImageComponent {
  @Input() title: string;
  @Input() subtitle: string;

}
